export type PropertyAccessCredential = {
  code: string;
  active: boolean;
};

export type Resident = {
  id: string;
  property_credentials: PropertyAccessCredential[];
  property_access_credential: PropertyAccessCredential;
  enable_directory_listing: boolean;
  directory_display_name: string;
  directory_sort_name: string;
  directory_lookup_code: string;
  directory_phone: string;
  user_enabled_video_calls: boolean;
};

export type Device = {
  id: string;
  enable_resident_directory: boolean;
  enable_numeric_codes: boolean;
  enable_qr_codes: boolean;
  enable_call_manager: boolean;
  enable_video_calls: boolean;
  schedule_days: ScheduleDay[];
  is_forced_open: boolean;
};

export type Property = {
  id: string;
  public_name: string;
  phone: string;
  timezone_id: string;
};

export type PropertyStaffUser = {
  id: string;
  property_access_credential: PropertyAccessCredential;
  property_credentials: PropertyAccessCredential[];
};

export type AccessRequest = {
  user_code: string;
  access_granted: boolean;
  created_at: string;
  source?: AccessRequestSource;
};

export type Days = {
  sun: string;
  mon: string;
  tue: string;
  wed: string;
  thu: string;
  fri: string;
  sat: string;
};

export type ScheduleDay = {
  day_of_week: keyof Days;
  open_time: string;
  close_time: string;
};

export type Notification = {
  status: string;
  title: string;
  body: string | null;
  sound: string | null;
};

export const createNotification = (
  status: string,
  title: string,
  body: string | null,
  sound: string | null
): Notification => ({
  status,
  title,
  body,
  sound,
});

export interface RecentCalls {
  [key: string]: number;
}
export interface AlphabetRefs {
  [key: string]: React.RefObject<any>; // this is the return type of React.createRef()
}
export interface Sounds {
  [key: string]: soundmanager.SMSound;
}

export enum Sound {
  Error = "error",
  Success = "success",
  Qr = "qr",
  SorryCode = "sorryCode",
  SorryError = "sorryError",
  SorryNoAccess = "sorryNoAccess",
  SorryNoAnswer = "sorryNoAnswer",
  Throttle = "throttle",
  Ring = "ring",
  Welcome = "welcome",
  GateOpen = "gateOpen",
}

export type Call = {
  intercomCallId: string;
  sip_password: string;
  sip_username: string;
  tenantId: string | null;
};

export type SIPMessage = {
  room: string;
  connected?: boolean;
  open?: boolean;
};

export type TelnyxNotification = {
  type: string;
  error?: Error;
  call: SIPCall;
};

export type ClientSDPMessage = {
  sdp: any;
  call_id: string;
  from: string;
};

export type ClientHangupMessage = {
  call_id: string;
  from?: string;
  open_gate?: boolean;
};

export type ClientDenyMessage = {
  call_id: string;
  open_gate?: boolean;
};

export type ClientCandidateMessage = {
  call_id: string;
  candidate: RTCIceCandidate;
};

//https://developers.telnyx.com/docs/api/v2/webrtc/js-sdk-call
export type SIPCall = {
  id: string;
  direction: string;
  prevState: string;
  state: string;
  localStream: MediaStream;
  remoteStream: MediaStream;
  answer: Function;
  hangup: Function;
};

export enum AccessRequestSource {
  Intercom = "Intercom",
  MobileIntercom = "MobileIntercom",
}
